import { useCallback, useMemo } from "react";
import { mutate } from "swr";

import { associateUserEndpoints } from "@api/Endpoints";
import { deleteData } from "@hooks/useDeleteData";

export function useRemoveAdmin() {
  const remove = useCallback(async (organizationId: string, userId: string) => {
    const url = associateUserEndpoints.disassociate(organizationId, userId);
    const result = await deleteData(url);
    const getUrl = associateUserEndpoints.get(organizationId);
    await mutate(getUrl);
    return result;
  }, []);
  return useMemo(() => ({ remove }), [remove]);
}
